const routes = [
  {
    path: "/knowledge-base",
    name: "knowledgeBase",
    component: () => import("views/EmptyView.vue"),
    redirect: { name: "knowledgeBaseIndex" },
    children: [
      {
        path: "add",
        name: "knowledgeBaseItemAdd",
        component: () =>
          import("pages/knowledge-base/KnowledgeBaseItemFormPage.vue"),
        meta: {
          title: "Nieuw artikel",
          layout: "MainLayoutNoWrapper",
          hideTitle: true,
        },
      },
      {
        path: ":slug/edit",
        name: "knowledgeBaseItemEdit",
        component: () =>
          import("pages/knowledge-base/KnowledgeBaseItemFormPage.vue"),
        meta: {
          title: "Artikel bewerken",
          layout: "MainLayoutNoWrapper",
          hideTitle: true,
        },
      },
      {
        path: "",
        name: "knowledgeBaseIndex",
        component: () => import("pages/knowledge-base/KnowledgeBaseIndex.vue"),
        meta: { title: "Ondersteuning", layout: "KnowledgeBaseLayout" },
        children: [
          {
            path: "feedback-form",
            name: "feedbackForm",
            component: () =>
              import("pages/knowledge-base/FeedbackFormDrawer.vue"),
            meta: { title: "Feedback formulier" },
          },
          {
            path: "help-form",
            name: "helpForm",
            component: () => import("pages/knowledge-base/HelpFormDrawer.vue"),
            meta: { title: "Help formulier" },
          },
          {
            path: "faq/add",
            name: "faqItemAdd",
            component: () =>
              import("components/knowledge-base/faq/FaqItemEdit.vue"),
            meta: {
              title: "FAQ-vraag toevoegen",
              layout: "KnowledgeBaseLayout",
            },
          },
          {
            path: "faq/:uuid/edit",
            name: "faqItemEdit",
            component: () =>
              import("components/knowledge-base/faq/FaqItemEdit.vue"),
            meta: {
              title: "FAQ-vraag bewerken",
              layout: "KnowledgeBaseLayout",
            },
          },
        ],
      },
      {
        path: ":slug",
        name: "knowledgeBaseItem",
        component: () => import("pages/knowledge-base/KnowledgeBaseSlug.vue"),
        meta: { title: "Kennisbank artikel", layout: "KnowledgeBaseLayout" },
        children: [
          {
            path: "help-form",
            name: "knowledgeBaseItemHelpForm",
            component: () => import("pages/knowledge-base/HelpFormDrawer.vue"),
            meta: { title: "Help formulier" },
          },
        ],
      },
    ],
  },
];

export default routes;
